module.exports = __webpack_public_path__ + "assets/img/25.c0a43dcb.png";